import { ErrorResponse } from "api/types"
import { format } from "date-fns"
import { FieldValues, UseFormSetError } from "react-hook-form"

export const getPlatformURL = (
  platform: "sso" | "learn" | "suraasa",
  url: string
) => {
  switch (platform) {
    case "sso":
      return `${import.meta.env.VITE_SSO_URL}${url}`
    case "learn":
      return `${import.meta.env.VITE_LEARN_PLATFORM_URL}${url}`
    case "suraasa":
      return `${import.meta.env.VITE_SURAASA_PLATFORM_URL}${url}`
    default:
      return url
  }
}

export type SetState<T> = React.Dispatch<React.SetStateAction<T>>

export const formatDate = (
  date: string | undefined | null,
  formatStr = "MMMM d, yyyy"
) => (date ? format(new Date(date), formatStr) : "")

/**
 * @param setter setter to set errors in the form
 * @param fieldErrors errors from the API
 * @param fields Format: [BackendKey, FrontendKey] OR [key] (if both key names are same)
 */
export const mapErrors = <T extends FieldValues>(
  setter: UseFormSetError<T>,
  { fieldErrors }: ErrorResponse["errors"],
  fields: ([string, string] | [string])[]
) => {
  fields.forEach(pair => {
    if (!fieldErrors) return
    const key = pair[0]

    const message = (() => {
      const errors = fieldErrors[key]

      if (Array.isArray(errors)) {
        return errors.join("; ")
      }

      if (typeof errors === "string") return errors

      return ""
    })()

    if (pair.length === 1) {
      if (message) {
        setter(key as any, {
          message,
        })
      }
    }
    if (pair.length === 2) {
      const frontendKey = pair[1]

      if (message) {
        setter(frontendKey as any, { message })
      }
    }
  })
}

export function pluralize(
  word: string,
  count: number,
  {
    endsWithVowel,
    skipCount,
    plural,
  }: {
    endsWithVowel?: boolean
    skipCount?: boolean
    plural?: string
  } = {
    endsWithVowel: false,
    skipCount: false,
    plural: "",
  }
) {
  let str = `${count} `

  if (skipCount) {
    str = ""
  }

  if (plural) {
    return `${count !== 1 ? `${str}${plural}` : `${str}${word}`}`
  }

  return `${
    count !== 1 ? `${str}${word}${endsWithVowel ? "es" : "s"}` : `${str}${word}`
  }`
}

export const formatNumberWithCommas = (num: number, locale = "en-IN") => {
  if (num === 0) {
    return null
  }
  return new Intl.NumberFormat(locale).format(Number(num.toFixed(0)))
}

export const convertToAnnual = (salary: number) => {
  return salary * 12
}
